import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/productions/ProductionsUIHelpers";

const initialProductionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  productionForEdit: undefined,
  lastError: null,
  type: null,
  listLoadingObjectData: false,
  objectsData: [],
  queryParams: initialFilter,
  cleanRefFilters: false
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const productionsSlice = createSlice({
  name: "productions",
  initialState: initialProductionsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    startCallObjectData: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingObjectData = true;
      } else {
        state.listLoadingObjectData = true;
      }
    },
    // getProductionById
    productionFetched: (state, action) => {
      state.actionsLoading = false;
      state.productionForEdit = action.payload.productionForEdit;
      state.error = null;
    },
    // findProductions
    productionsFetched: (state, action) => {
      const { totalCount, entities, type } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.productionForEdit = null;
      state.type = type;
    },
    // deleteProduction
    productionDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    productionCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    productionUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // Query Params
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    // ObjectsData
    objectsDataFetchedByType: (state, action) => {
      const { objectsData } = action.payload;
      state.error = null;
      state.objectsData = objectsData.map(x => {
        return {...x, label: `${x.searchKey} | ${x.objectType}`}
      });
      state.actionsLoading = false;
    },
    // Clean Filter
    setValueCleanRefFilter: (state, action) => {
      state.cleanRefFilters= action.payload.flag;
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    endCleanRefFilter: (state, action) => {
      state.cleanRefFilters= action.payload.flag;
    },
  }
});
